export const OPACITY_FADE_TRANSITION = {
  enterActiveClass: 'transition-opacity duration-200 ease-out',
  leaveActiveClass: 'transition-opacity duration-150 ease-in',
  enterFromClass: 'opacity-0',
  enterToClass: 'opacity-100',
  leaveFromClass: 'opacity-100',
  leaveToClass: 'opacity-0',
} as const;

export const SCALE_FADE_TRANSITION = {
  enterActiveClass: 'transition-[opacity,scale] duration-[240ms] ease-snappy',
  leaveActiveClass: 'transition-[opacity,scale] duration-150 ease-snappy',
  enterFromClass: 'opacity-0 scale-[0.96] motion-reduce:scale-100',
  enterToClass: 'opacity-100 scale-100',
  leaveFromClass: 'opacity-100 scale-100',
  leaveToClass: 'opacity-0 scale-[0.98] motion-reduce:scale-100',
} as const;
